import PropTypes from "prop-types";

/** Attorney / bond number / other-details historic steps. */
export const HISTORIC_DATA_UPDATE_ERRORS = {
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

/** Basic information forms with wizard `globalData`. */
export const HISTORIC_GLOBAL_BASIC_FORM = {
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

/** Requestor steps that receive `bondData`. */
export const HISTORIC_REQUESTOR_WITH_BOND = {
  data: PropTypes.object.isRequired,
  bondData: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

/** Historic creatable wrappers (mirrors retrieval `MenuList`). */
export const HISTORIC_VIRTUALIZED_MENU_LIST = {
  options: PropTypes.array.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  maxHeight: PropTypes.number.isRequired,
};

/** Labeled react-select wrappers used by historic VA / Trustee / Probate / Guardianship. */
export const HISTORIC_LABELED_CREATABLE = {
  label: PropTypes.node.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
